import React from 'react';

export const ContactUsPage = () => (
    <div className="space-y-4">
        <h2 className="text-4xl font-extrabold text-center text-indigo-700 dark:text-indigo-300 mb-6 transition-colors duration-300">Contact Us</h2>
        <p className="text-lg leading-relaxed text-center text-gray-700 dark:text-gray-100 transition-colors duration-300">
            Have questions or want to get in touch? We'd love to hear from you!
        </p>
        <div className="max-w-xl mx-auto bg-gray-50 dark:bg-gray-900 p-8 rounded-lg shadow-md transition-colors duration-300 text-center space-y-4">
            <p className="text-gray-700 dark:text-gray-200">Reach us directly via Email!</p>
            <a
                href="mailto:chicodarts530@gmail.com?subject=Chico%20Darts%20Inquiry"
                className="inline-block bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline transition duration-200"
            >
                Contact Chico Darts
            </a>
        </div>
    </div>
);